




































































































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, InputTime, CheckBox } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

// models
import { WorkShiftForm, InfoDayModel } from '@/models/config'

// constants
import { optionsStatus, weekDays } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { WorkShiftService } from '@/services/config'

@Component({
    name: 'FormCreateEditWorkShift',
    components: {
        Input,
        Radio,
        InputTime,
        CheckBox
    },
    mixins: [validationMixin]
})
export default class FormCreateEditWorkShift extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) workShift!: WorkShiftForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: WorkShiftForm = {
        name: '',
        checkin_time: '',
        checkout_time: '',
        lunch_time_entry: '',
        lunch_time_ends: '',
        week_days: [],
        is_active: true,
        is_cumulative: false,
        is_nocturnal: false
    }

    created () {
        if (this.idEdit) {
            this.form = {
                name: this.workShift.name,
                checkin_time: this.workShift.checkin_time,
                checkout_time: this.workShift.checkout_time,
                lunch_time_entry: this.workShift.lunch_time_entry,
                lunch_time_ends: this.workShift.lunch_time_ends,
                week_days: [],
                is_active: this.workShift.is_active,
                is_cumulative: this.workShift.is_cumulative,
                is_nocturnal: this.workShift.is_nocturnal
            }
            this.workShift.week_days.forEach(day => {
                this.form.week_days.push({
                    key: day.key,
                    name: day.name
                })
            })
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                checkin_time: { required },
                checkout_time: { required },
                lunch_time_entry: { required },
                lunch_time_ends: { required },
                week_days: {
                    required,
                    minLength: minLength(1),
                    $each: {
                        key: { required },
                        name: { required }
                    }
                },
                is_active: { required }
            }
        }
    }

    checkDay (checked: boolean, day: InfoDayModel) {
        if (checked) {
            this.form.week_days.push(day)
        } else {
            for (let index = 0; index < this.form.week_days.length; index++) {
                const element = this.form.week_days[index]
                if (element.key === day.key) {
                    this.form.week_days.splice(index, 1)
                    break
                }
            }
        }
    }

    dayInWorkShif (day: InfoDayModel): boolean {
        for (let index = 0; index < this.form.week_days.length; index++) {
            const element = this.form.week_days[index]
            if (element.key === day.key) {
                return true
            }
        }
        return false
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await WorkShiftService.update(this.idEdit, this.form)
                } else {
                    await WorkShiftService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    name: '',
                    checkin_time: '',
                    checkout_time: '',
                    lunch_time_entry: '',
                    lunch_time_ends: '',
                    week_days: [],
                    is_active: true,
                    is_cumulative: false,
                    is_nocturnal: false
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    get weekDays (): InfoDayModel[] {
        return weekDays
    }
}
